import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { PerguntaFormComponent } from 'src/app/pages/pergunta-form/pergunta-form.component';

@Injectable()
export class PerguntaGuard implements CanDeactivate<PerguntaFormComponent> {
  canDeactivate(component: PerguntaFormComponent): Observable<boolean> | boolean {
    if (component.novoRegistro) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    } else { return true; }
  }
}
